import { render, staticRenderFns } from "./NewOrderSampleGrid.vue?vue&type=template&id=5746c324&"
import script from "./NewOrderSampleGrid.vue?vue&type=script&lang=js&"
export * from "./NewOrderSampleGrid.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderSampleGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/NewOrderSampleGrid.vue
// module id = null
// module chunks = 